import { Component, OnInit,ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ItemService } from 'app/shared/services/item.service';
import { AuthService } from 'app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-item-category',
  templateUrl: './item-category.component.html',
  styleUrls: ['./item-category.component.css']
})
export class ItemCategoryComponent implements OnInit {

  isDark: boolean = false;

  displayedColumns: string[] = ['itemCategory','createdBy','action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  data : any[];  

  itemCategory : any;
  itemCategoryForm: FormGroup;
  isValidFormData: boolean = true;
  showProcessingIndicator = false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


  validationMessages = {
    'itemCategory': { 'required': 'Item category is required' },
  };

  formErrors = {
    'itemCategory': "",
  };

  constructor(private fb: FormBuilder,
    private itemService: ItemService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private router : Router, 
    private themeService: NbThemeService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {

    this.getItemCategoryList();
    this.getControlPermissions();
    this.itemCategory = {
      id: null,
      itemCategory : '',
      createdBy : '',
    }

    this.itemCategoryForm = this.fb.group({
      id: [null],
      itemCategory : ['', Validators.required],    
      createdBy: [''],
    });

   

    this.itemCategoryForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.itemCategoryForm);
    });

    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });



  }//end oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='IC'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  resetForm(){
    this.itemCategoryForm.reset();
  }

  saveButtonClick(): void {

    this.logValidationErrors(this.itemCategoryForm, true);
    this.mapFormValuesToModel();

    if (this.isFilledFromFields()) {

        this.showProcessingIndicator = true;
        this.itemService.addItemCategory(this.itemCategory)
          .subscribe(
            (res) => {

              if(res.success === 0){
                this.toastr.error(res.message, 'warning');
                this.showProcessingIndicator = false;
              }else if(res.success === 1){
                this.toastr.success('Item Category added successfully', 'Success');
                this.showProcessingIndicator = false;
                this.getItemCategoryList();
                this.resetForm();

              }
                         
            },
            (err) => {
              this.toastr.error('Failed to add item category', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
          )
      } else {  
          this.toastr.warning('Required Fields cannot be empty or invalid.', 'Error Message');
          this.showProcessingIndicator = false;
    }


  }


  enableForm(): void {
    Object.keys(this.itemCategoryForm.controls).forEach(key => {
      this.itemCategoryForm.controls[key].enable();
      console.log(key)
    });
  }


  disableForm(): void {
    Object.keys(this.itemCategoryForm.controls).forEach(key => {
      this.itemCategoryForm.controls[key].disable();
    });
  }

  logValidationErrors(group: FormGroup = this.itemCategoryForm, isDirty: boolean = false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (isDirty) {
        this.enableForm();
        this.itemCategoryForm.controls[key].markAsTouched();
      }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }


  isFilledFromFields(): boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
        return false;
    }
    return true;
  }

  mapFormValuesToModel() {
    this.itemCategory.id = this.itemCategoryForm.value.id;
    this.itemCategory.itemCategory = this.itemCategoryForm.value.itemCategory;
    this.itemCategory.createdBy = this.authService.getUserLoggedIn();

  }





    getItemCategoryList(){
      this.itemService.getAllItemCategory()
       .subscribe(
          (data) => {
                    this.data = data;
                    this.dataSource = new  MatTableDataSource (this.data);  
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;                    
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }


       deleteButtonClick(id : number){
        this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
        .afterClosed().subscribe(res =>{
          if(res){
            this.itemService.deleteItemCategory(id)
          .subscribe(
            (res) => {
                        this.toastr.success('Item Category deleted','Success');
                        this.getItemCategoryList();
                        console.log(res);     
                      },        
            (err) =>  {
                        this.toastr.error('Failed to delete record','Failure');
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      }, 
              )
          }
        });            
    }
  
    applyFilter(){
      this.dataSource.filter =this.searchKey.trim().toLowerCase();
  
    }
    
    onSearchClear(){
      this.searchKey = "";
      this.applyFilter();
    }





}// end class
